var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((parseInt(_vm.value)),function(s){return _c('i',{key:'f'+s,staticClass:"bi-star-fill text-blue h4 me-1"})}),(_vm.value % 1 > 0)?_c('i',{staticClass:"bi-star-half text-blue h4 me-1"}):_vm._e(),_vm._l((parseInt(5 - _vm.value)),function(s){return _c('i',{key:'e'+s,staticClass:"bi-star text-blue h4 me-1"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }